import { Injectable } from '@angular/core';
import { BitrateStats, QualityStats } from '../../models/app/precall/bitrate-result';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class AudioBitrateStore extends BaseStore<{
  partial?: BitrateStats;
  complete?: QualityStats;
}> {}
